import styled, { css } from 'styled-components';

import { mobileFirstBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

/**
 * Indent variations:
 *
 * You should use a padding / margin css notation without `px`.
 *
 * Static
 * $united: 4
 * $united: 4, 6 // 4 for horizontal and 6 for vertical (aka top-bottom, left-right of a css margin or padding)
 * $united: 4, 6, 8 // 4 for top, 6 for vertical and 8 for bottom (aka top, left-right, bottom of a css margin or padding);
 * $united: 4, 6, 8, 12 //  4 for top, 6 for right, 8 for bottom and 12 for left (aka top/right/bottom/left of a css margin or padding);
 *
 * Dynamic
 * $mobile: 4, $desktop: 16
 * $mobile: 4, 8, $desktop: 12, 16
 * $mobile: 4, 8, 12, $desktop: 8, 12, 16
 * $mobile: 4, 8, 12, 16, $desktop: 8, 12, 16, 20
 */
export const indents = [0, 4, 8, 12, 16, 20, 24, 32, 36, 40, 48, 64, 80] as const;

export type Indent = typeof indents[number];

/**
 * Проверяет принадлежит ли переданное число типу Indent
 */
export const isIndent = (_number: number): _number is Indent => {
    return !!indents.find(el => el === _number);
};

type StaticIndent = [Indent];
type TopRightPattern = [Indent, Indent];
type TopRightBottomPattern = [Indent, Indent, Indent];
type FullPattern = [Indent, Indent, Indent, Indent];

type TUnionIndentPattern = StaticIndent | TopRightPattern | TopRightBottomPattern | FullPattern

export type TContainerProps = {
    $united: TUnionIndentPattern,
    $mobile?: never,
    $desktop?: never,
} | {
    $united?: never,
    $mobile: TUnionIndentPattern,
    $desktop: TUnionIndentPattern,
}

const getMarginFromCompositeValue = (indent: TUnionIndentPattern) => indent.map(item => `${item}px`).join(' ');

export const getPaddingByIncomingIndent = ({ $united, $mobile, $desktop }: TContainerProps) => {
    if ($united) {
        return css`
            padding: ${getMarginFromCompositeValue($united)};
        `;
    } else if ($mobile && $desktop) {
        return css`
            padding: ${getMarginFromCompositeValue($mobile)};

            @media (min-width: ${mobileFirstBreakpoints.mobile}) {
                padding: ${getMarginFromCompositeValue($desktop)};
            }
        `;
    }
};

const IndentContainer = styled.div<TContainerProps>`
    display: block;

    ${getPaddingByIncomingIndent};
`;

export default IndentContainer;
